import React, { useCallback, useState } from 'react'
import { DashboardCard } from './OutstandingBalance'
import { useTheme } from '../../../middleware/ThemeContext'
import CardIconHeader, { IconCircle } from './Components/CardIconHeader';
import ContactRoleIcon from '../../../assets/icons/ContactRoleIcon';
import StyledText from '../../../components/StyledComponents/StyledText';
import { font } from '../../../utils/themes';
import { ActionType, Column, TableConfig } from '../../../types/types';
import { DropResult } from '@hello-pangea/dnd';
import DataTable from '../../../components/listing/DataTable';
import { Button } from '../../../components/form/Button';
import ArrowIcon from '../../../assets/icons/ArrowIcon';

type Members = {
    contactId: number,
    contactFirstName: string,
    contactLastName: string,
    contactSignedUrl: string,
    issue: string,
    priority: string,
    status: string,
}

const data = [
    {
        contactId: 1,
        contactFirstName: 'Bob',
        contactLastName: 'Smith',
        contactSignedUrl: '',
        issue: 'Payment Failed',
        priority: 'High',
        status: 'Overdue',
    },
    {
        contactId: 2,
        contactFirstName: 'Sarah',
        contactLastName: 'Johnson',
        contactSignedUrl: '',
        issue: 'Missing ID Document',
        priority: 'Low',
        status: 'Overdue',
    },
    {
        contactId: 3,
        contactFirstName: 'Tech',
        contactLastName: 'Corp',
        contactSignedUrl: '',
        issue: 'Pending Approval',
        priority: 'Medium',
        status: 'Overdue',
    },
    {
        contactId: 4,
        contactFirstName: 'Michle',
        contactLastName: 'Chen',
        contactSignedUrl: '',
        issue: 'Payment Failed',
        priority: 'High',
        status: 'Overdue',
    },
    {
        contactId: 5,
        contactFirstName: 'Emily',
        contactLastName: 'Jones',
        contactSignedUrl: '',
        issue: 'Pending Approval',
        priority: 'Low',
        status: 'Overdue',
    }
];

const MembersNeedAttention = () => {
    const {theme} = useTheme();

    const columns: Column[] = [
        { id: "primaryUser", label: "Members", isSortable: false },
        { id: "issue", label: "Issue", isSortable: false },
        { id: "priority", label: "Priority", isSortable: false },
        { id: "status", label: "Status", isSortable: false },
    ];

    const tableData =
    (data as Members[]).map((item) => ({
        contactId: item.contactId,
        contactFirstName: item.contactFirstName,
        contactLastName: item.contactLastName,
        contactSignedUrl: item.contactSignedUrl,
        issue: item.issue,
        priority: item.priority,
        status: item.status,
      }));

    const STORAGE_KEY = `tableConfig_ignore`;
      const [tableConfig, setTableConfig] = useState<TableConfig>(() => {
        const saved = sessionStorage.getItem(STORAGE_KEY);
        return saved
          ? JSON.parse(saved)
          : {
            visibleColumns: columns.filter(col => col.id !== "id").map(col => col.id),
            page: 1,
            perPage: 10,
            sort: undefined,
            filters: {},
            query: "",
            columnOrder: columns.map(col => col.id),
          };
      });
    
      const handleDragEnd = useCallback(
        (result: DropResult) => {
          if (!result.destination) return;
          const newColumnOrder = Array.from(tableConfig.columnOrder);
          const [removed] = newColumnOrder.splice(result.source.index, 1);
          newColumnOrder.splice(result.destination.index, 0, removed);
          setTableConfig(prev => ({ ...prev, columnOrder: newColumnOrder }));
        },
        [tableConfig.columnOrder]
      );

      const handleAction = useCallback(async (action: ActionType, id: string) => {
        const numericId = Number(id);
    
        if (action === 'view') {
            return;
        }
    
        }, []);

  return (
    <DashboardCard theme={theme} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div className='d-flex align-items-center justify-content-between mb-4'>
            <div className='d-flex align-items-center gap-3'>
                <IconCircle style={{ backgroundColor: 'rgba(228, 228, 255, 0.5)' }}>
                    <ContactRoleIcon size={22} Color={theme.CorporateTheme.colors.ultraMarineBlue} />
                </IconCircle>
                <StyledText
                    fontSize='16px'
                    fontWeight={700}
                    textColor={theme.CorporateTheme.colors.primary}
                >
                    Members Who Need Attention
                </StyledText>
            </div>
            <div 
                style={{
                    borderRadius: '43px',
                    backgroundColor: theme.CorporateTheme.colors.headerBG,
                    padding: '10px 15px'
                }}
            >
                <StyledText
                    fontSize='14px'
                    fontWeight={500}
                    textColor={theme.CorporateTheme.colors.textSecondary}
                >
                    <span style={{ fontFamily: font.lato }}>5</span> Tasks
                </StyledText>
            </div>
        </div>

        <DataTable
            routeKey='membersAttention'
            title='Members Attention'
            // profiledName
            hideActionColumn={false}
            columns={columns}
            data={tableData}
            columnOrder={tableConfig.columnOrder}
            visibleColumns={tableConfig.visibleColumns}
            sort={tableConfig.sort}
            noDataTitle="No Contact Found"
            noDataSubtitle="Members list is currently empty."
            onDragEnd={handleDragEnd}
            loading={false}
            perPage={tableConfig.perPage}
            onAction={handleAction}
            minWidth="1000px"
        />
        <span className='my-3' />
        <Button
            theme={theme}
            $variant='customButton'
            textColor={theme.CorporateTheme.colors.primary}
            color={theme.CorporateTheme.colors.primary}
            fontSize='12px'
            fontWeight='600'
            borderColor={theme.CorporateTheme.colors.filterBG}
            width='100%'
            textPosition='start'
        >
            View all Members
            <ArrowIcon rotate='right' color={theme.CorporateTheme.colors.gunmetal} />
        </Button>
    </DashboardCard>
  )
}

export default MembersNeedAttention